import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
const Getters: GetterTree<any, any> = {
  [types.INITIAL_TIME_STAMP](state, getters, rootState) {
    return state.initTime;
  },
  [types.GETTER_DOUBLE_COIN_BUBBLE_STATUS](state, getters, rootState) {
    return state.showDoubleCoinBubble;
  },
  [types.GETTER_SUPER_PAY_BUBBLE_STATUS](state, getters, rootState) {
    return state.showSuperPayBubble;
  },
  [types.GETTER_SUPER_PAY_BUBBLE_SHOW_DATE](state, getters, rootState) {
    return state.showSuperPayBubbleDate;
  },
  [types.GETTER_SUPER_PAY_BUBBLE_CLICK](state, getters, rootState) {
    return state.superPayBubbleClick;
  },
  [types.GETTER_LIMITED_COIN_SHOW](state, getters, rootState) {
    return state.isShowLimtedCoin;
  },
  [types.GETTER_LIMITED_COIN_INTERVAL_TIME](state, getters, rootState) {
    return state.limtedIntervalTime;
  },
  [types.GETTER_LIMITED_COIN_BUBBLE_STATUS](state, getters, rootState) {
    return state.isShowLimtedCoinBubble;
  },
  [types.GETTER_SUPER_PAY_RECOMMEND_CLICK_DATE](state, getters, rootState) {
    return state.superPayRecommendClickDate;
  }
};

export default Getters;
